import axiosClient from "./axiosClient";

export const buildApiUrl = (baseUrl, params) => {
  const queryString = Object.entries(params)
    .filter(([key, value]) => value !== "" && value !== null && key !== 'region')
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join("&");

  return queryString ? `${baseUrl}?${queryString}` : baseUrl; // Append query string if not empty
};

const farmApi = {
  getFarms() {
    const url = "/admin/getFarms";
    return axiosClient.get(url);
  },
  getTestHistory(payload) {
    const url = buildApiUrl("/admin/getTestHistory", payload);
    return axiosClient.get(url);
  },
  getTestDetailList(id) {
    const url = `/getTestDetailsList/${id}`;
    return axiosClient.get(url);
  },

  getStatisticFarm(payload) {
    const url = buildApiUrl("/statisic/farms", payload);
    return axiosClient.get(url);
  },

  getFilterFarms(payload){
    const url = buildApiUrl("/getFilterFarms", payload);
    return axiosClient.get(url);
  },

  // Detail Result
  getDetailResult(payload) {
    const url = buildApiUrl("/statisic/ketQuaChiTiet", payload);
    return axiosClient.get(url);
  },

  getAssessment(payload) {
    const url = buildApiUrl("/statisic/hinhThucDanhGia", payload);

    return axiosClient.get(url);
  },

  getStatisticAssessment(payload) {
    const url = buildApiUrl("/statisic/hinhThucDanhGiaBieuDo", payload);
    return axiosClient.get(url);
  },

  // Frequency

  getFrequency(payload) {
    const url = buildApiUrl("/statisic/repeatation", payload);
    return axiosClient.get(url);
  },


  // Export 
  exportDetailResult(payload) {
    const url = buildApiUrl("/statisic/ketQuaChiTiet/export/excel", payload);
    return axiosClient.get(url);
  },

  exportFrequency(payload) {
    const url = buildApiUrl("/statisic/repeatation/export/excel", payload);
    return axiosClient.get(url);
  },
};

export default farmApi;
